<header>
  <mat-toolbar style="background-color:#5775a8; min-height: 100px; max-height: 100px">
    <div class="flex flex-row w-full items-center">
      <div class="flex justify-center">
        <a href="http://www.oregon.gov/oha/ph/pages/index.aspx" target="_blank" title="Oregon Health Authority">
          <img src="../../../assets/images/OHA-Black.png" style="width: 198px; height: 75px;"
            alt="Indoor Clean Air Act - Tobacco Prevention and Education Program" />
        </a>

        <div class="flex items-center">
          <span class="p-l-16">
            <a href="http://public.health.oregon.gov/PreventionWellness/TobaccoPrevention/SmokefreeWorkplaceLaw/Pages/index.aspx"
              target="_blank" class="navbar-brand" title="Oregon's Indoor Clean Air Act" style="color: white;">
              Indoor Clean Air Act
              <br>
              Tobacco Prevention and Education Program
            </a>
          </span>
        </div>
      </div>
    </div>
  </mat-toolbar>
</header>
<div class="flex justify-center pt-4" role=“main”>
  <div *ngIf="status == 'edit'" class="w-9/12 column flex flex-col matero-content-wrap">
    <div class="flex flex-row justify-start items-center gap-4">
      <span>
        <h1 class="text-lg font-semibold">{{"complaint.header1" | translate}}</h1>
      </span>
      <app-translate class="ml-auto"></app-translate>
    </div>

    <br />

    <div *ngIf="error" class="alert alert-danger"><span style="color: red;">{{"validations.errorNotice" |
        translate}}</span> </div>

    <div class="bg-blue-200 rounded-lg p-8">
      {{"complaint.headerTxt1" | translate}}
      <br /><br />
      {{"complaint.headerTxt2" | translate}} <b>{{"complaint.headerTxt3" | translate}}</b>{{"complaint.headerTxt4" |
      translate}}
      <br /><br />
      {{"complaint.headerTxt5" | translate}}<b>{{"complaint.headerTxt6" | translate}}</b>{{"complaint.headerTxt7" |
      translate}}
      <br /><br />
      {{"complaint.headerTxt9" | translate}}
      <a href="http://www.healthoregon.org/morefreshair" class="formLink" title="Oregon's Indoor Clean Air Act"
        id="CleanAirActLink" target="_blank"><b>{{"complaint.headerTxt8" | translate}}</b></a>
    </div>

    <br />

    <span class="text-muted">{{"complaint.headerTxt10" | translate}} </span>
    <br />
    <br />

    <div class="flex justify-center bg-blue-200 rounded-lg p-8 ">
      <h2><b>{{"complaint.header2" | translate}}</b></h2>
    </div>

    <form [formGroup]="form">
      <!-- <form [formGroup]="form" (ngSubmit)="submitRequest()"> -->
      <div class="flex flex-row sm:flex-row">
        <div class="sm:w-full" style="padding-right: 10px;">
          <mat-form-field class="w-full">
            <mat-label>{{"complaintForm.county" | translate}}</mat-label>
            <mat-select formControlName="countyId">

              <mat-option *ngFor="let list of countyList" [value]="list.value">
                {{list.text}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('countyId').invalid">
              {{"validations.required" | translate}}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="sm:w-full">
          <mat-form-field class="w-full">
            <mat-label>{{"complaintForm.businessName" | translate}}</mat-label>
            <input matInput formControlName="businessName">
            <mat-error *ngIf="form.get('businessName').hasError('required')">
              {{"validations.required" | translate }}
            </mat-error>
            <mat-error *ngIf="form.get('businessName').hasError('pattern')">
              {{"validations.invalid_characters" | translate}}
            </mat-error>
            <mat-error *ngIf="form.get('businessName').hasError('maxlength')">
              {{"validations.maxlength" | translate: {number: '50'} }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="flex flex-row sm:flex-row gap-4 sm:gap-0">
        <div class="w-1/2 sm:w-full" style="padding-right: 10px;">
          <mat-form-field class="w-full">
            <mat-label>{{"complaintForm.typeOfBusiness" | translate}}</mat-label>
            <mat-select formControlName="busCatId" (onclick)="setBusinessList()">

              <mat-option *ngFor="let list of typeOfBusinessList" [value]="list.value">
                {{list.text}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('busCatId').invalid">
              {{"validations.required" | translate}}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="w-1/2 sm:w-full">
          <div fxLayout="row">
            <mat-form-field class="w-full">
              <mat-label>{{"complaintForm.complaint" | translate}}</mat-label>
              <textarea matInput cdkTextareaAutosize formControlName="businessComplaint"></textarea>
              <mat-error *ngIf="form.get('businessComplaint').invalid">
                {{"validations.required" | translate}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="flex flex-row sm:flex-row">
        <div class="sm:w-full" style="padding-right: 10px;">
          <mat-form-field class="w-full">
            <mat-label>{{"complaintForm.businessAddress1" | translate}}</mat-label>
            <input matInput formControlName="businessAddress1">
            <mat-error *ngIf="form.get('businessAddress1').invalid">
              {{"validations.maxlength" | translate: {number: '50'} }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="sm:w-full">
          <mat-form-field class="w-full">
            <mat-label>{{"complaintForm.businessAddress2" | translate}}</mat-label>
            <input matInput formControlName="businessAddress2">
            <mat-error *ngIf="form.get('businessAddress2').invalid">
              {{"validations.maxlength" | translate: {number: '50'} }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="flex flex-row sm:flex-row">
        <div class="sm:w-full" style="padding-right: 10px;">
          <mat-form-field class="w-full">
            <mat-label>{{"complaintForm.businessCity" | translate}}</mat-label>
            <input matInput formControlName="businessCity">
            <mat-error *ngIf="form.get('businessCity').invalid">
              {{"validations.required" | translate}}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="sm:w-full">
          <mat-form-field class="w-full">
            <mat-label>{{"complaintForm.businessState" | translate}}</mat-label>
            <input matInput formControlName="businessState" readonly="true">
            <mat-error *ngIf="form.get('businessState').invalid">
              {{"validations.required" | translate}}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="flex flex-row sm:flex-row">
        <div class="sm:w-full" style="padding-right: 10px;">
          <mat-form-field class="w-full">
            <mat-label>{{"complaintForm.businessZipCode" | translate}}</mat-label>
            <input matInput formControlName="businessZipCode">
            <mat-error *ngIf="form.get('businessZipCode').invalid">
              {{"validations.maxlength" | translate: {number: '10'} }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="sm:w-full">
          <mat-form-field class="w-full">
            <mat-label>{{"complaintForm.businessPhone" | translate}}</mat-label>
            <input matInput formControlName="businessPhone" placeholder="(xxx)xxx-xxxx">
            <mat-error *ngIf="form.get('businessPhone').invalid">
              {{"validations.errorNotice" | translate}}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="flex flex-row sm:flex-row">
        <div class="sm:w-full" style="padding-right: 10px;">
          <mat-form-field class="w-full">
            <mat-label>{{"complaintForm.businessPhoneExt" | translate}}</mat-label>
            <input matInput formControlName="businessPhoneExt">
            <mat-error *ngIf="form.get('businessPhoneExt').invalid">
              {{"validations.maxlength" | translate: {number: '6'} }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="sm:w-full">
        </div>
      </div>

      <br />

      <div class="flex justify-center bg-blue-200 rounded-lg p-8 ">
        <h2><b>{{"complaint.header3" | translate}}</b></h2>
      </div>

      <div class="flex flex-col">
        <mat-checkbox formControlName="contactByEmail"
          (change)="contactType('email', $event)">{{"complaintForm.contactByEmail" | translate}}
        </mat-checkbox>
        <mat-checkbox formControlName="contactByMail"
          (change)="contactType('mail', $event)">{{"complaintForm.contactByMail" | translate}}
        </mat-checkbox>
      </div>

      <div *ngIf="contactBy==1">

        <div class="flex flex-row sm:flex-row">
          <div class="sm:w-full" style="padding-right: 10px;">
            <mat-form-field class="w-full">
              <mat-label>{{"complaintForm.contactName" | translate}}</mat-label>
              <input matInput formControlName="contactName">
              <mat-error *ngIf="form.get('contactName').invalid">
                {{"validations.required" | translate}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="sm:w-full">
            <mat-form-field class="w-full">
              <mat-label>{{"complaintForm.contactEmail" | translate}}</mat-label>
              <input matInput formControlName="contactEmail">
              <mat-error *ngIf="form.get('contactEmail').invalid">
                {{"validations.required" | translate}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

      </div>

      <div *ngIf="contactBy==2">

        <div class="flex flex-row sm:flex-row">
          <div class="sm:w-full" style="padding-right: 10px;">
            <mat-form-field class="w-full">
              <mat-label>{{"complaintForm.contactName" | translate}}</mat-label>
              <input matInput formControlName="contactName">
              <mat-error *ngIf="form.get('contactName').invalid">
                {{"validations.required" | translate}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="sm:w-full">
          </div>
        </div>

        <div class="flex flex-row sm:flex-row">
          <div class="sm:w-full" style="padding-right: 10px;">
            <mat-form-field class="w-full">
              <mat-label>{{"complaintForm.contactAddress" | translate}}</mat-label>
              <input matInput formControlName="contactAddress">
              <mat-error *ngIf="form.get('contactAddress').invalid">
                {{"validations.required" | translate}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="sm:w-full">
            <mat-form-field class="w-full">
              <mat-label>{{"complaintForm.contactCity" | translate}}</mat-label>
              <input matInput formControlName="contactCity">
              <mat-error *ngIf="form.get('contactCity').invalid">
                {{"validations.required" | translate}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="flex flex-row sm:flex-row">
          <div class="sm:w-full" style="padding-right: 10px;">
            <mat-form-field class="w-full">
              <mat-label>{{"complaintForm.contactState" | translate}}</mat-label>
              <mat-select formControlName="contactState">
                <mat-option *ngFor="let state of stateList" [value]="state.value">
                  {{state.text}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('contactState').invalid">
                {{"validations.required" | translate}}
              </mat-error>
            </mat-form-field>

          </div>

          <div class="sm:w-full">
            <mat-form-field class="w-full">
              <mat-label>{{"complaintForm.contactZipCode" | translate}}</mat-label>
              <input matInput formControlName="contactZipCode">
              <mat-error *ngIf="form.get('contactZipCode').invalid">
                {{"validations.required" | translate}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div *ngIf="contactBy != 0" class="flex flex-row sm:flex-row">
        <div class="sm:w-full" style="padding-right: 10px;">
          <mat-form-field class="w-full">
            <mat-label>{{"complaintForm.contactPhone" | translate}}</mat-label>
            <input matInput formControlName="contactPhone" placeholder="(xxx)xxx-xxxx">
            <mat-error *ngIf="form.get('contactPhone').invalid">
              {{"validations.errorNotice" | translate}}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="sm:w-full">
          <mat-form-field class="w-full">
            <mat-label>{{"complaintForm.contactPhoneExt" | translate}}</mat-label>
            <input matInput formControlName="contactPhoneExt">
            <mat-error *ngIf="form.get('contactPhoneExt').invalid">
              {{"validations.maxlength" | translate: {number: '6'} }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <br />
      <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full m-8"
        (click)="next()">{{"control.nextButton" | translate}}</button>

    </form>
  </div>

  <div *ngIf="status == 'list'" class="w-9/12 column">
    <div class="row">
      <h1><b>{{"complaint.header4" | translate}}</b></h1>
    </div>
    <br />
    <div class="flex justify-center bg-blue-200 rounded-lg p-8 ">
      <h2><b>{{"complaint.header5" | translate}}</b></h2>
    </div>

    <div class="rounded-lg p-8 row">
      <div class="w-4/12 column">
        <div><b>{{"complaintForm.county" | translate}}</b></div>
        <div>{{translateCounty(form.controls['countyId'].value)}}</div>
      </div>
      <div class="w-4/12">
        <div><b>{{"complaintForm.businessName" | translate}}</b></div>
        <div>{{form.controls['businessName'].value}}</div>
      </div>
      <div class="w-4/12">
        <div><b>{{"complaintForm.typeOfBusiness" | translate}}</b></div>
        <div>{{translateTypeOfBusiness(form.controls['busCatId'].value)}}</div>
      </div>
    </div>

    <div class="rounded-lg p-8 row">
      <div class="w-4/12 column">
        <div><b>{{"complaintForm.businessAddress1" | translate}}</b></div>
        <div>
          {{form.controls['businessAddress1'].value}} <br />
          {{form.controls['businessCity'].value + ' ' + form.controls['businessState'].value + ' ' +
          form.controls['businessZipCode'].value}}
        </div>
      </div>
      <div class="w-4/12">
      </div>
      <div class="w-4/12">
        <div><b>{{"complaintForm.businessAddress2" | translate}}</b></div>
        <div>{{form.controls['businessAddress2'].value}}</div>
      </div>
    </div>

    <div class="rounded-lg p-8 row">
      <div class="w-4/12 column">
        <div><b>{{"complaintForm.businessPhone" | translate}}</b></div>
        <div>{{form.controls['businessPhone'].value}}</div>
      </div>
      <div class="w-4/12">
        <div><b>{{"complaintForm.businessPhoneExt" | translate}}</b></div>
        <div>{{form.controls['businessPhoneExt'].value}}</div>
      </div>
      <div class="w-4/12">
      </div>
    </div>

    <div *ngIf="contactBy == 1" class="rounded-lg p-8 row">
      <div class="w-4/12 column">
        <div><b>{{"complaintForm.contactName" | translate}}</b></div>
        <div>{{form.controls['contactName'].value}} </div>
      </div>
      <div class="w-4/12">
        <div><b>{{"complaintForm.contactEmail" | translate}}</b></div>
        <div>{{form.controls['contactEmail'].value}} </div>
      </div>
      <div class="w-4/12">
        <div><b>{{"complaintForm.contactPhone" | translate}}</b></div>
        <div>{{form.controls['contactPhone'].value}} </div>
      </div>
    </div>

    <div *ngIf="contactBy == 2" class="rounded-lg p-8 row">
      <div class="w-4/12 column">
        <div><b>{{"complaintForm.contactName" | translate}}</b></div>
        <div>{{form.controls['contactName'].value}}</div>
      </div>
      <div class="w-4/12">
        <div><b>{{"complaintForm.contactAddress" | translate}}</b></div>
        <div>{{form.controls['contactAddress'].value}} <br />
          {{form.controls['contactCity'].value + ' ' + getStateName(form.controls['contactState'].value) + ' ' +
          form.controls['contactZipCode'].value}}
        </div>
      </div>
      <div class="w-4/12">
        <div><b>{{"complaintForm.contactPhone" | translate}}</b></div>
        <div>{{form.controls['contactPhone'].value}}</div>
      </div>
    </div>

    <div class="rounded-lg p-8 row">
      <div class="w-8/12 column">
        <div><b>{{"complaintForm.complaint" | translate}}</b></div>
        <div>{{form.controls['businessComplaint'].value}}</div>
      </div>
      <div class="w-4/12">
      </div>
    </div>

    <div>
      <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full m-8"
        (click)="editComplaint()">
        {{"control.editButton" | translate}}
      </button>
    </div>

    <br />

    <div class="flex justify-center bg-blue-200 rounded-lg p-8 ">
      <h2><b>{{"complaint.header6" | translate}}</b></h2>
    </div>
    <br />

    <div>
      {{"complaint.headerTxt13" | translate}}
      <a (click)="fileTypes()" class="formLink" title="FileTypes"> {{"complaint.headerTxt14" | translate}}</a>
      {{"complaint.headerTxt15" | translate}} <b>{{"complaint.headerTxt16" | translate}}</b> {{"complaint.headerTxt17" |
      translate}}
    </div>

    <div class="column">
      <div class="row">
        <div class="row w-6/12">
          <input type="file" class="file-input" (change)="uploadFile1($event)"
            accept=".gif, .jpg, .jepg, .png, .bmp, .pdf" hidden="true" #csvFileUpload1>
          <button mat-raised-button class="m-8" color="accent" (click)="csvFileUpload1.click()">
            {{"complaint.chooseFile" | translate}} <mat-icon>attach_file</mat-icon>
          </button>
          <div class="flex items-center justify-center">{{fileName1}}</div>
        </div>
        <div class="row w-6/12 flex items-center">
          <mat-icon color="warn">delete</mat-icon>
          <a (click)="removeFile1()">{{"control.remove" | translate}}</a>
        </div>
      </div>

      <div class="row">
        <div class="row w-6/12">
          <input type="file" class="file-input" (change)="uploadFile2($event)"
            accept=".gif, .jpg, .jepg, .png, .bmp, .pdf" hidden="true" #csvFileUpload2>
          <button mat-raised-button class="m-8" color="accent" (click)="csvFileUpload2.click()">
            {{"complaint.chooseFile" | translate}} <mat-icon>attach_file</mat-icon>
          </button>
          <div class="flex items-center justify-center">{{fileName2}}</div>
        </div>
        <div class="row w-6/12 flex items-center">
          <mat-icon color="warn">delete</mat-icon>
          <a (click)="removeFile2()">{{"control.remove" | translate}}</a>
        </div>
      </div>
    </div>

    <br />
    <button *ngIf="!submitted" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full m-8"
      (click)="submitRequest()">
      {{"control.submitButton" | translate}}
    </button>
  </div>

  <div *ngIf="status == 'done'" class="w-9/12 column">
    <div class="rounded-lg p-8 row" style="background-color: aquamarine;">
      {{"complaint.submitted" | translate}}
    </div>
  </div>

</div>

<br />
<br />
<br />

<mat-toolbar class="mt-10 w-full fixed bottom-0" style="min-height: 40px; max-height: 40px;">
  <div class="absolute right-10">
    <span class="f-s-12 p-r-16">Oregon Health Authority</span>
    <a class="f-s-12 p-r-16" href="http://public.health.oregon.gov/PreventionWellness/TobaccoPrevention/SmokefreeWorkplaceLaw/Pages/index.aspx" target="_blank" rel="noreferrer noopener">
      Indoor Clean Air Act
    </a>
    <span class="f-s-12 p-r-16">
      {{environment.build}} Version {{environment.version}}
    </span>
    <a class="f-s-12" target="_blank" (click)="gotoPage('accessibilityNotice')" rel="noreferrer noopener"> 
      Accessibility
    </a>
 </div>
</mat-toolbar>

